<template>
  <div 
    class="form-input" 
    :class="{ 
      'form-input--full': isFull, 
      'form-input--error': error,
      'form-input--disabled': disabled,
    }"
  >
    <input 
      :type="type" 
      :disabled="disabled" 
      :value="value" 
      @input="onChange"
      :placeholder="placeholder"
    />
    <span class="form-input__label">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'FormInput',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    full: {
      type: [Boolean, String, Number],
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  computed: {
    isFull() {
      if (this.value === '' || this.value === null) return false;
      return true;
    }
  },
  methods: {
    onChange(e) {
      if (this.type === 'number') {
        if (e.target.value?.match(/\.\d{3,}/)) {
          e.preventDefault()
          const newValue = Math.floor(+e.target.value * 100) / 100;
          e.target.value = newValue;
          this.$emit('change', newValue);
        } else {
          this.$emit('change', e.target.value)
        }
      }
      this.$emit('change', e.target.value)
    }
  }
}
</script>